export default __webpack_public_path__ + "static/media/SPELL.9c658b0e.png";